import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import Cards from '../widgets/cards/cards';

class Home extends Component {
    render() {
        return (
            <div>
                <Row>
                    <Col>
                        <h2>Welcome To The World Of Robots</h2>
                        <br/>
                    </Col>
                </Row>
                <Cards />
            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/home/home.js